import React from 'react';
import shallowequal from 'shallowequal';
import { HotTable } from '@handsontable/react';
import { omit } from 'lodash';

import { ReactHotTable } from 'shared/components/other';
import { AdfoxCampaign } from 'types/tradingDesk/adfox';

type Props = {
  columns: ReactHotTable.Column[];
  campaigns: AdfoxCampaign[];
  defaultCampaigns: AdfoxCampaign[];
  onChange: (data: AdfoxCampaign[]) => void;
  initTable: (hot: HotTable | null) => void;
};

const Table: React.FC<Props> = (props) => {
  const { columns, campaigns, defaultCampaigns, onChange, initTable } = props;

  return (
    <ReactHotTable.Component
      rows={campaigns}
      defaultRows={defaultCampaigns}
      columns={columns}
      onChange={onChange as never}
      initTable={initTable}
    />
  );
};

export const AdfoxTable = React.memo(Table, (prevProps, nextProps) => {
  return shallowequal(omit(prevProps, ['campaigns']), omit(nextProps, ['campaigns']));
});
